import { DependencyList, EffectCallback, useEffect, useRef } from "react"

/**
 * useGtZeroEffect hook 首次不执行，后续执行
 * @param fn 首次
 * @param deps
 */
export function useGtZeroEffect(fn: EffectCallback, deps?: DependencyList) {
  const count = useRef(0)

  useEffect(() => {
    if (count.current == 0) {
      count.current++
      return
    }
    // PS,需要销毁 同 useEffect
    return fn()
  }, deps)
}
